import { createAction } from '@reduxjs/toolkit'
import { Token } from 'config/types'

export const updateDeviceUid = createAction<{ deviceUid: string }>('session/updateDeviceUid')
export const selectPlayBalance = createAction<{ token: Token }>('session/selectPlayBalance')
export const addSearchHistoryText = createAction<{ text: string }>('session/addSearchHistoryText')
export const removeSearchHistoryText = createAction<{ text: string }>('session/removeSearchHistoryText')
export const clearSearchHistory = createAction('session/clearSearchHistory')
